import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./CustomerWaitingForPayment.module.css";
import useAuthGuard from "../hooks/useAuthGuard";

const CustomerWaiting = () => {
  useAuthGuard();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const cartId = query.get("cart_id");
    console.log("Waiting Page - cartId from URL:", cartId);
    setTimeout(() => {
      console.log("Still on waiting page, navigating manually with cartId:", cartId);
      navigate(`/customer-payment-success?cart_id=${cartId}`);
    }, 5000);
  }, [navigate, location.search]);

  return (
    <div className={styles.container}>
      <h2>Processing Your Payment...</h2>
      <p>Please wait while we verify your transaction.</p>
      <div className={styles.loader}></div>
    </div>
  );
};

export default CustomerWaiting;
